export const PermissionComponents = {
    PUT: "mgr-components-**-PUT",
    POST: "mgr-components-POST",
    DELETE: "mgr-components-**-DELETE",
    GET: "mgr-components-**-GET",
    GET_UUID: "mgr-components-**-GET",
};